import placeholderImage from "@/assets/images/placeholder.png";
import osakaImage from "@/assets/images/destinations/osaka.png";
import nagoyaImage from "@/assets/images/destinations/nagoya.png";
import naraImage from "@/assets/images/destinations/nara.png";
import hiroshimaImage from "@/assets/images/destinations/hiroshima.png";
import tokyoImage from "@/assets/images/destinations/tokyo.png";
import hokkaidoImage from "@/assets/images/destinations/hokkaido.png";
import fukuokaImage from "@/assets/images/destinations/fukuoka.png";
import kobeImage from "@/assets/images/destinations/kobe.png";
import parisImage from "@/assets/images/destinations/paris.webp";
import madridImage from "@/assets/images/destinations/madrid.webp";
import romeImage from "@/assets/images/destinations/rome.webp";
import milanImage from "@/assets/images/destinations/milan.webp";
import newYorkImage from "@/assets/images/destinations/new-york.webp";
import amsterdamImage from "@/assets/images/destinations/amsterdam.webp";
import barcelonaImage from "@/assets/images/destinations/barcelona.webp";
import singaporeImage from "@/assets/images/destinations/singapore.webp";
import seoulImage from "@/assets/images/destinations/seoul.webp";
import dubaiImage from "@/assets/images/destinations/dubai.webp";
import losAngelesImage from "@/assets/images/destinations/los-angeles.webp";
import istanbulImage from "@/assets/images/destinations/istanbul.webp";
import taipeiImage from "@/assets/images/destinations/taipei.webp";
import berlinImage from "@/assets/images/destinations/berlin.webp";
import hongKongImage from "@/assets/images/destinations/hong-kong.webp";
import londonImage from "@/assets/images/destinations/london.webp";
import bangkokImage from "@/assets/images/destinations/bangkok.webp";

const destinationImages = [
  { names: ["京都", "京都府", "kyoto"], url: "/images/templates/kyoto.webp" },
  { names: ["箱根"], url: "/images/templates/hakone.webp" },
  { names: ["沖縄", "沖縄県", "那覇", "那覇市"], url: "/images/templates/okinawa.webp" },
  { names: ["北海道", "札幌"], url: hokkaidoImage },
  { names: ["東京", "東京都", "tokyo"], url: tokyoImage },
  { names: ["大阪", "大阪府", "大阪市", "osaka"], url: osakaImage },
  { names: ["名古屋", "名古屋市"], url: nagoyaImage },
  { names: ["福岡", "福岡県", "福岡市"], url: fukuokaImage },
  { names: ["広島", "広島県", "広島市"], url: hiroshimaImage },
  { names: ["奈良", "奈良県", "奈良市"], url: naraImage },
  { names: ["神戸", "神戸市"], url: kobeImage },
  { names: ["パリ", "paris"], url: parisImage },
  { names: ["マドリッド", "マドリード", "madrid"], url: madridImage },
  { names: ["ローマ", "rome"], url: romeImage },
  { names: ["ミラノ", "milan"], url: milanImage },
  { names: ["ニューヨーク", "new york", "new york city", "nyc"], url: newYorkImage },
  { names: ["アムステルダム", "amsterdam"], url: amsterdamImage },
  { names: ["バルセロナ", "barcelona"], url: barcelonaImage },
  { names: ["シンガポール", "singapore"], url: singaporeImage },
  { names: ["ソウル", "seoul"], url: seoulImage },
  { names: ["ドバイ", "dubai"], url: dubaiImage },
  { names: ["ロサンゼルス", "los angeles"], url: losAngelesImage },
  { names: ["イスタンブール", "イスタンブル", "istanbul", "i̇stanbul"], url: istanbulImage },
  { names: ["台北", "台北市", "taipei"], url: taipeiImage },
  { names: ["ベルリン", "berlin"], url: berlinImage },
  { names: ["香港", "hong kong"], url: hongKongImage },
  { names: ["ロンドン", "london"], url: londonImage },
  { names: ["バンコク", "bangkok"], url: bangkokImage },
];

const shioriDestinationNames = new Set([
  "京都", "京都府", "kyoto", "東京", "東京都", "tokyo", "大阪", "大阪府", "大阪市", "osaka",
  "パリ", "paris", "マドリッド", "マドリード", "madrid", "ローマ", "rome", "ミラノ", "milan",
  "ニューヨーク", "new york", "new york city", "nyc", "アムステルダム", "amsterdam",
  "バルセロナ", "barcelona", "シンガポール", "singapore", "ソウル", "seoul", "ドバイ", "dubai",
  "ロサンゼルス", "los angeles", "イスタンブール", "イスタンブル", "istanbul", "i̇stanbul",
  "台北", "台北市", "taipei", "ベルリン", "berlin", "香港", "hong kong", "ロンドン", "london",
  "バンコク", "bangkok",
].map((name) => normalizeDestinationName(name)));

function normalizeDestinationName(name = "") {
  return String(name).normalize("NFKC").trim().toLowerCase();
}

function matchesDestinationName(normalizedName, alias) {
  const normalizedAlias = normalizeDestinationName(alias);
  const escapedAlias = normalizedAlias.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const separator = "[\\s,，、/／・()（）［］【】「」『』:：-]";
  return new RegExp(`(^|${separator})${escapedAlias}(?=$|${separator})`).test(normalizedName);
}

function aiImageUrl(candidate = {}) {
  const report = candidate.AI_RESEARCH_REPORT;
  if (!report) return "";
  try {
    const parsed = typeof report === "string" ? JSON.parse(report) : report;
    return parsed.imageUrl || parsed.image_url || parsed.heroImageUrl || parsed.hero_image_url || "";
  } catch (_error) {
    return "";
  }
}

export function destinationFallbackImage(name = "") {
  const normalized = normalizeDestinationName(name);
  return destinationImages.find(({ names }) => names.some((item) => matchesDestinationName(normalized, item)))?.url || placeholderImage;
}

export function knownShioriDestinationImage(name = "") {
  const normalized = normalizeDestinationName(name);
  return destinationImages.find(({ names }) => names.some((item) => (
    shioriDestinationNames.has(normalizeDestinationName(item)) && matchesDestinationName(normalized, item)
  )))?.url || "";
}

export function resolveCandidateImage(candidate = {}, fetchedImageUrl = "") {
  return fetchedImageUrl ||
    candidate.IMAGE_URL || candidate.imageUrl || candidate.image_url ||
    candidate.AI_IMAGE_URL || candidate.aiImageUrl || aiImageUrl(candidate) ||
    destinationFallbackImage(candidate.CANDIDATE_NAME);
}

export function candidateExternalLinks(name = "") {
  const normalized = String(name).trim();
  if (!normalized) return [];
  const tag = normalized.replace(/[#\s\u3000]+/g, "");
  const encodedName = encodeURIComponent(normalized);
  return [
    {
      key: "instagram",
      icon: "brand-instagram",
      label: `Instagramで${normalized}を調べる`,
      url: `https://www.instagram.com/explore/tags/${encodeURIComponent(tag)}/`,
    },
    {
      key: "maps",
      icon: "brand-googlemaps",
      label: `Google マップで${normalized}を見る`,
      url: `https://www.google.com/maps/search/?api=1&query=${encodedName}`,
    },
    {
      key: "flights",
      icon: "brand-skyscanner",
      label: "Skyscannerで航空券を調べる",
      url: "https://www.skyscanner.jp/transport/flights/",
    },
    {
      key: "hotels",
      icon: "brand-bookingdotcom",
      label: `Booking.comで${normalized}の宿泊施設を調べる`,
      url: `https://www.booking.com/searchresults.html?ss=${encodedName}`,
    },
  ];
}

export { placeholderImage };
